import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { errMsg, useApi } from "@/lib/api";
import ScoreCards from "./ScoreCards";
import QualityIssues from "./QualityIssues";
import OptimizationSummary from "./OptimizationSummary";
import LighthousePanel from "./LighthousePanel";
import ChecksList from "@/components/sites/ChecksList";

export default function QualityPanel({ site, deploys }) {
  const api = useApi();
  const target = deploys.find((d) => d.status === "ready");
  const [dep, setDep] = useState(null);
  const [error, setError] = useState("");
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    setDep(null); setError("");
    if (target) api.get(`/sites/${site.id}/deploys/${target.id}`).then(({ data }) => setDep(data)).catch((e) => setError(errMsg(e)));
  }, [api, site.id, target?.id, retry]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!target) return <p className="text-sm text-slate-500" data-testid="quality-empty">Nessuna compilazione riuscita: compila il sito per vedere qualità e ottimizzazioni.</p>;
  if (error) return <p className="text-sm text-red-700" data-testid="quality-load-error">Impossibile caricare la compilazione: {error} <button type="button" className="underline" onClick={() => setRetry((n) => n + 1)} data-testid="quality-load-retry">Riprova</button></p>;
  if (!dep) return <Loader2 size={14} className="animate-spin text-slate-400" />;
  const q = dep.checks?.quality;
  return (
    <div className="space-y-5" data-testid="quality-panel">
      <p className="text-xs text-slate-500">Compilazione n. {dep.number}: punteggi automatici calcolati dai file compilati (stima gratuita, non è Lighthouse). Per i valori reali misura con Lighthouse qui sotto.</p>
      {q ? (
        <>
          <ScoreCards quality={q} />
          <OptimizationSummary optimization={dep.report?.optimization} />
          <QualityIssues quality={q} />
        </>
      ) : (
        <>
          <p className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900" data-testid="quality-old-build">Questa compilazione è precedente alle ottimizzazioni automatiche: usa «Compila ora» per vedere punteggi e consigli.</p>
          <ChecksList checks={dep.checks} />
        </>
      )}
      <LighthousePanel site={site} routes={dep.report?.routes} />
    </div>
  );
}
